import styled, {css} from "styled-components/macro";
import {device} from "../../styles";
import {IsVisibleOnMobile} from "../../data";

export const Root = styled.div<IsVisibleOnMobile>`
    margin-top: 20px;
    
    ${device.less768} {
        display: none;
        padding: 0;
        margin: 0;

        ${(props) => props.$isVisibleOnMobile && css`
            display: block;
        `}
    }
`;

export const Head = styled.div`
`;

export const Title = styled.div`
    font-family: 'Mazzard L', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 26px;
    color: var(--color-accent);
    text-transform: uppercase;

    ${device.less1180} {
        font-size: 18px;
    }

    ${device.less768} {
        font-size: 14px;
        line-height: 15px;
    }
`;

export const Description = styled.div`
    display: flex;
    margin-top: 5px;
    font-family: LatoWeb, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 28px;
    color: rgba(37, 37, 37, 0.5);
    
    * {
        flex: 1;
    }
    
`;
